import type { IMetaMenuItem, IRichText, ITextMetaMenuItem, IUspListMetaMenuItem, IUspMetaMenuItem } from '~/lib/data-contract/auto-generated/api-model';

export interface IEnhancedMetaMenuItem extends IMetaMenuItem {
	richText?: IRichText;
}

export type MetaHeaderItemUnion = IEnhancedMetaMenuItem | ITextMetaMenuItem | IUspListMetaMenuItem;
export type MetaHeaderSingleItemUnion = IEnhancedMetaMenuItem | ITextMetaMenuItem | IUspMetaMenuItem;

export const isTextMetaMenuItem = (item: MetaHeaderItemUnion): item is ITextMetaMenuItem => {
	return item.type === 'textMetaMenuItem';
};

export const isUspListMetaMenuItem = (item: MetaHeaderItemUnion): item is IUspListMetaMenuItem => {
	return item.type === 'uspListMetaMenuItem';
};

export const isBasicMetaMenuItem = (item: MetaHeaderItemUnion): item is IEnhancedMetaMenuItem => {
	return item.type === 'metaMenuItem';
};

export type LayoutStrategy = 'row' | 'animation';

export interface LayoutDecision {
	strategy: LayoutStrategy;
	containerWidth: number;
	itemsRowWidth: number;
	canFitInRow: boolean;
}

export interface MeasurementState {
	isInitialRender: boolean;
	containerWidth: number;
	itemsRowWidth: number;
	hasMeasured: boolean;
}

export interface EnhancedMetaHeaderItemsProps {
	items: MetaHeaderItemUnion[];
}
